<template>
  <v-card>
    <v-card-title>
      <span :class="['headline indigo--text text--darken-2 font-weight-medium']">{{ header1 }}</span>
      <span :class="['headline indigo--text text--darken-2 ml-2']">{{ obj.header }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text style="height: 120px;">
      <v-row class="mt-5">
        <v-col cols="12">
          <v-text-field :label="label" v-model="item.text" outlined></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn v-if="!inNewMode" color="red darken-1" text @click="obj.remove(obj.item)">Delete</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="obj.update(obj.item.text)">Update</v-btn>
      <v-btn color="green darken-1" text @click="obj.close()">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { getFormattedValue } from "../../shared.js";

export default {
  props: {
    obj: Object
  },
  name: "DialogSettingsFieldUpdate",
  data() {
    return {};
  },
  computed: {
    item() {
      return this.obj.item;
    },
    inNewMode() {
      return this.obj.inNewMode;
    },
    header1() {
      if (this.inNewMode) return "New";
      return "Edit";
    },
    label() {
      if (this.inNewMode) return "Enter a new " + this.obj.header;
      else return "Edit this " + this.obj.header;
    }
  },
  methods: {}
};
</script>

<style scoped>
</style>
